import React from 'react'

import styles from './Navigation.module.scss'

export const Navigation = ({ children }) => (
  <nav className={styles.navigation}>
    <ul className={styles.menu}>{children}</ul>
  </nav>
)
